module.exports = __webpack_public_path__ + "img/Beneficio_4.0e15aa27.webp";